<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
    v-model="activeTab"
  >
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? $t('users.account') : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-general :data="$store.state.AppActiveUser" :show-header="isSmallerScreen" />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? $t('users.change_password') : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-change-password :data="$store.state.AppActiveUser" :show-header="isSmallerScreen" />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? $t('users.information') : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-info :data="$store.state.AppActiveUser" :show-header="isSmallerScreen" />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-folder"
      :label="!isSmallerScreen ? $t('employees.employee_panel') : ''"
    >
      <div class="tab-text">
        <user-settings-employment
          class="mt-4"
          :data="$store.state.AppActiveUser"
          :show-header="isSmallerScreen"
        />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-dollar-sign"
      :label="!isSmallerScreen ? $t('businesses.business_panel') : ''"
    >
      <div class="tab-text">
        <user-settings-business
          class="mt-4"
          :data="$store.state.AppActiveUser"
          :show-header="isSmallerScreen"
          @change-tab="changeActiveTab"
        />
      </div>
    </vs-tab>
    <!--<vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notifications' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <user-settings-notifications />
      </div>
    </vs-tab>-->
  </vs-tabs>
</template>

<script>
import UserSettingsGeneral from './UserSettingsGeneral.vue'
import UserSettingsChangePassword from './UserSettingsChangePassword.vue'
import UserSettingsInfo from './UserSettingsInfo.vue'
import UserSettingsBusiness from './UserSettingsBusiness'
import UserSettingsEmployment from './UserSettingsEmployment'

export default {
  components: {
    UserSettingsEmployment,
    UserSettingsBusiness,
    UserSettingsGeneral,
    UserSettingsChangePassword,
    UserSettingsInfo
  },
  data() {
    return { activeTab: 0 }
  },
  methods: {
    changeActiveTab(tabIndex) {
      this.activeTab = tabIndex
    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
